import { Injectable } from '@angular/core';
import { EncryptionService } from './encryption.service';



@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(public eService: EncryptionService) {}

  setLocal<T>(key: string, item: T, secure = false) {
    this.setItem(localStorage, key, item, secure);
  }

  setSession<T>(key: string, item: T, secure = false) {
    this.setItem(sessionStorage, key, item, secure);
  }

  getLocal<T>(key: string): T {
    return this.getItem(localStorage, key);
  }

  getSession<T>(key: string): T {
    return this.getItem(sessionStorage, key);
  }

  removeLocal(key: string, secure?: boolean) {
    let sitekey = 'pgh';
    if (secure) {
      this.removeItem(localStorage, key + '-e-' + sitekey);
    } else {
      this.removeItem(localStorage, key + '-' + sitekey);
    }
  }

  clearLocal() {
    const sitekey = 'pgh'; // this.configService.clientShortId();
    const langItem = localStorage.getItem('language' + '-' + sitekey);
    const elitaEnv = localStorage.getItem('elita-environment' + '-' + sitekey);
    const elitaEnvDefault = localStorage.getItem('elita-environment-default' + '-' + sitekey);

    const usernameAttemptCounts = localStorage.getItem('usernameAttemptCounts');
    const sessionItem = localStorage.getItem('SessionId-e-pgh');
    const userSessionId = localStorage.getItem('UserSessionId' + '-' + sitekey);
    localStorage.clear();
    localStorage.setItem('language' + '-' + sitekey, langItem);
    elitaEnv && localStorage.setItem('elita-environment' + '-' + sitekey, elitaEnv);
    elitaEnvDefault && localStorage.setItem('elita-environment-default' + '-' + sitekey, elitaEnvDefault);
    sessionItem && localStorage.setItem('SessionId-e-pgh', sessionItem)
    userSessionId && localStorage.setItem('UserSessionId' + '-' + sitekey, userSessionId);

    if (usernameAttemptCounts) {
      localStorage.setItem('usernameAttemptCounts', usernameAttemptCounts);
    }
  }

  clearSession() {
    sessionStorage.clear();
  }

  removeSession(key: string, secure?: boolean) {
    let sitekey = 'pgh';
    if (secure) {
      this.removeItem(sessionStorage, key + '-e-' + sitekey);
    } else {
      this.removeItem(sessionStorage, key + '-' + sitekey);
    }
  }

  private setItem<T>(storage: Storage, key: string, item: T, secure?: boolean) {
    let sitekey = 'pgh'; // this.configService.clientShortId();

    if (secure) {
      storage.setItem(key + '-e-' + sitekey, this.eService.enc(JSON.stringify(item)));
    } else {
      storage.setItem(key + '-' + sitekey, JSON.stringify(item));
    }
  }

  private getItem<T>(storage: Storage, key: string): T {
    let sitekey = 'pgh'; // this.configService.clientShortId();

    const cachedItem = JSON.parse(storage.getItem(key + '-' + sitekey));
    if (cachedItem !== null) {
      return cachedItem;
    } else {
      const cachedItem2: T = JSON.parse(this.eService.dec(storage.getItem(key + '-e-' + sitekey)));
      if (cachedItem2 !== null) {
        return cachedItem2;
      }
    }
    return null;
  }

  private removeItem<T>(storage: Storage, key: string) {
    storage.removeItem(key);
  }
}

interface ICacheItem<T> {
  item: T;
}
